import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trumpet',
  templateUrl: './trumpet.component.html',
  styleUrls: ['./trumpet.component.scss']
})
export class TrumpetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
